import {contract, domain} from "@typesec/mrpc";
import z from "zod";
import {CredentialsSchema, SessionSchema} from "./schema/auth.mjs";
import {
    CreatedRelayEndpointSchema,
    PlacementRegionInfoSchema,
    RelayCreateInputSchema,
    RelayEndpointSchema,
} from "./schema/relay.mjs";

export const SignInContract = contract({
    input: CredentialsSchema,
    output: SessionSchema,
});

export const SessionContract = contract({
    input: z.strictObject({}),
    output: SessionSchema.nullable(),
});

export const SignOutContract = contract({
    input: z.strictObject({}),
    output: z.null(),
});

/** Returns the new session expiry, or null when there was nothing to refresh. */
export const RefreshContract = contract({
    input: z.strictObject({}),
    output: z.number().nullable(),
});

export const RegionListContract = contract({
    input: z.strictObject({}),
    output: z.array(PlacementRegionInfoSchema),
});

export const RelayCreateContract = contract({
    input: RelayCreateInputSchema,
    output: CreatedRelayEndpointSchema,
});

export const RelayListContract = contract({
    input: z.strictObject({}),
    output: z.array(RelayEndpointSchema),
});

export const RelayRotateContract = contract({
    input: z.strictObject({id: z.string()}),
    output: CreatedRelayEndpointSchema,
});

export const RelayRemoveContract = contract({
    input: z.strictObject({id: z.string()}),
    output: z.null(),
});

export const RelaySetStateContract = contract({
    input: z.strictObject({id: z.string(), active: z.boolean()}),
    output: RelayEndpointSchema,
});

export const ClientDomain = domain("Client", {
    auth: {
        signIn: SignInContract,
        session: SessionContract,
        signOut: SignOutContract,
        refresh: RefreshContract,
    },
    regions: {
        list: RegionListContract,
    },
    relay: {
        create: RelayCreateContract,
        list: RelayListContract,
        rotate: RelayRotateContract,
        setState: RelaySetStateContract,
        remove: RelayRemoveContract,
    },
});
